import { render, staticRenderFns } from "./AwsCustomOnboardingList.vue?vue&type=template&id=555ea15a&"
import script from "./AwsCustomOnboardingList.vue?vue&type=script&lang=js&"
export * from "./AwsCustomOnboardingList.vue?vue&type=script&lang=js&"
import style0 from "./AwsCustomOnboardingList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports